import { ChangeEvent } from 'react';
import styled from '@emotion/styled';
import { Search as SearchIcon } from '@mui/icons-material';
import { TextField } from '@mui/material';
import { useTranslation } from 'src/hooks';
import { IconButton, SvgIcon, Typography } from 'src/components/atoms';

interface Props {
  text: string;
  searchField: string;
  onSearchFieldChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const StyledHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 2.5rem;
`;

const StyledSearchField = styled(TextField)`
  max-width: 15rem;

  .MuiInput-root {
    &::before {
      content: '';
      border-bottom: 1px solid white;
    }
  }

  input {
    padding: 0.2rem;
    padding-bottom: 0;
    font-size: 14px;
  }
`;

export const ContainerHeader = ({ text, searchField, onSearchFieldChange }: Props) => {
  const { t } = useTranslation();

  return (
    <StyledHeaderContainer>
      <Typography variant='h5'>{text}</Typography>
      <StyledSearchField
        value={searchField}
        variant='standard'
        color='primary'
        size='small'
        placeholder={t('pages.mymes.editor.blobs.library.container_search')}
        onChange={onSearchFieldChange}
        InputProps={{
          endAdornment: (
            <IconButton sx={{ mb: -0.5, mr: -0.5 }}>
              <SvgIcon fontSize='medium' color='primary'>
                <SearchIcon />
              </SvgIcon>
            </IconButton>
          )
        }}
      />
    </StyledHeaderContainer>
  );
};
